import { useMutation, useQueryClient } from '@tanstack/vue-query';
import httpClient from '../httpClient';
import type { MantaPatient } from '@/types';
import type { SpeciesKey } from '@/lib/species';

export interface CreatePatientPayload {
  name: string;
  species?: SpeciesKey;
  /** Optional owner to link the new patient to. */
  client_id?: string;
}

/** Creates a real patient in manta (via the scribe-backend proxy). */
export const usePatientCreate = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (
      payload: CreatePatientPayload,
    ): Promise<MantaPatient> => {
      const response = await httpClient.post<MantaPatient>(
        '/v1/patients',
        payload,
      );
      return response.data;
    },
    onSuccess: (_created, payload) => {
      if (!payload.client_id) return;
      void queryClient.invalidateQueries({
        queryKey: ['scribeClientPatients', payload.client_id],
      });
    },
  });
};
